<template>
  <Container class="PkiCertificateList__container">
    <ItemListPagination
      v-if="!noResults"
      :columns="columns"
      :currentPageNum="currentPageNum"
      :isLoading="isLoading"
      :itemComponent="$options.PkiCertificatesRow"
      :rowsPerPage="rowsPerPage"
      :selectAll="selectAll"
      :selectable="selectable"
      :showEmptyState="showEmptyState"
      :sortBy="sortBy"
      :sortDirection="sortDirection"
      :tableData="displayedItems"
      :totalCount="totalCount"
      @pageChange="handlePageChange"
      @select="handleSelect"
      @selectAll="handleSelectAll"
      @showDetails="handleShowDetails"
      @sortColumn="handleSortColumn"
    >
      <template v-slot:toolbar>
        <PkiToolbar
          :columns="columns"
          :hasSelectedCertificates="!!selectedCertificates.length"
          @columnSelect="handleColumnSelect"
          @configureList="handleConfigureList"
          @exportData="handleExportData"
          @restoreColumns="handleRestoreColumns"
          @search="handleSearch"
        />
      </template>
      <template v-slot:emptyState>
        <NoSearchResults
          :src="$options.noResultsIllustration"
          @click="clearSearchTerm"
        />
      </template>
    </ItemListPagination>
  </Container>
</template>

<script>
import {
  Container,
  ItemListPagination,
  NoSearchResults,
} from '@jumpcloud/ui-components';
import { pkiCertQuickFilters, pkiCertificateColumns } from 'client/Pki/Constants';
import Constants from 'client/util/Constants';
import PkiCertificatesRow from 'client/Pki/components/PkiCertificatesRow.vue';
import PkiToolbar from 'client/Pki/PkiCertificates/PkiToolbar.vue';

const { noResultsIllustration } = Constants;

const defaultRowsPerPage = 20;
const defaultSortBy = 'status';
const defaultSortDirection = 'ascending';
const newCertMappingRoute = '';

export default {
  name: 'PkiCertificateList',

  components: {
    Container,
    ItemListPagination,
    NoSearchResults,
    PkiToolbar,
  },

  PkiCertificatesRow,
  pkiCertQuickFilters,
  pkiCertificateColumns,
  noResultsIllustration,

  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      columns: pkiCertificateColumns,
      currentPageNum: 0,
      newCertMappingRoute,
      isLoading: false,
      noResults: false,
      rowsPerPage: defaultRowsPerPage,
      selectable: true,
      selectAll: false,
      shouldFocusSearch: false,
      showEmptyState: false,
      sortBy: defaultSortBy,
      sortDirection: defaultSortDirection,
      selectedCertificates: [],
      totalCount: this.tableData.length,
    };
  },

  computed: {
    displayedItems() {
      return this.tableData.slice(this.currentPageNum, this.rowsPerPage);
    },
  },

  methods: {
    clearSearchTerm() {
      this.handleEnterSearchTerm('');
      this.shouldFocusSearch = true;
    },

    handleColumnSelect(columns) {
      this.columns = columns;
    },

    handleConfigureList() {
      // @todo
    },

    handleExportData() {
      // @todo handle data export
      this.$emit('exportData');
    },

    async handlePageChange(payload = {}) {
      const {
        currentPageNum = this.currentPageNum,
        rowsPerPage = this.rowsPerPage,
      } = payload;

      this.isLoading = true;

      this.currentPageNum = currentPageNum;
      this.rowsPerPage = rowsPerPage;

      this.isLoading = false;
    },

    handleRestoreColumns() {
      this.columns = this.columns.map(column => ({
        ...column,
        visible: true,
      }));
    },

    async handleSearch(value) {
      if (value.length && !value.trim().length) {
        this.isLoading = false;
        return;
      }

      this.isLoading = true;
      this.searchTerm = value;

      this.shouldFocusSearch = false;
      this.currentPageNum = 0;

      // @todo setPage method from the collection module

      this.isLoading = false;
    },

    handleSelect(certificate) {
      const certificates = [...this.selectedCertificates];
      const certificateIndex = certificates.indexOf(certificate);

      if (certificateIndex > -1) {
        certificates.splice(certificateIndex, 1);
      } else {
        certificates.push(certificate);
      }

      this.selectedCertificates = certificates;
    },

    async handleSelectAll() {
      // @todo logic for preserving the state of the selected rows when toggled
    },

    handleShowDetails() {
      // @todo
    },

    async handleSortColumn(payload = {}) {
      const {
        dataFieldName = this.sortBy,
        sortDirection = this.sortDirection,
      } = payload;

      this.sortBy = dataFieldName;
      this.sortDirection = sortDirection;
    },
  },
};
</script>

<style scoped>
.PkiCertificateList__container {
  background: var(--jc-color-surface-light);
}
</style>
